import { useSyncExternalStore } from 'react';

// The admin's currently-selected "Active Station" (sidebar dropdown).
// null = "All my stations". Persisted per browser; every adminApi request
// carries it as X-Active-Station so the API narrows vendor visibility
// server-side (apps/api adminAuth -> effectiveScope). The API ignores values
// outside the user's assignment, so a stale stored value can't widen access.

const KEY = 'l2u.admin.activeStation';

function readStored(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

let current: string | null = readStored();
const listeners = new Set<() => void>();

export function getActiveStation(): string | null {
  return current;
}

export function setActiveStation(value: string | null): void {
  current = value;
  try {
    if (value === null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, value);
  } catch {
    // Storage unavailable (private mode) — in-memory value still applies.
  }
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useActiveStation(): string | null {
  return useSyncExternalStore(subscribe, getActiveStation);
}
